import loggerStyle from "./commandLogger.module.css";

import { useState, useContext, useMemo, useCallback } from "react";
import { IOBlock } from "../../../../sdkStructs.ts";

import { useNavigate } from "react-router-dom";

import TokenWidget from "./components/TokenWidget/TokenWidget.tsx";
import CommandWidget from "./components/CommandWidget/CommandWidget.tsx";
import VulnWidget from "./components/VulnWidget/VulnWidget.tsx";
import { AuthContext } from "../../../../contexts/AuthContext.ts";
import { PentestContext } from "../../../../contexts/PentestContext.ts";
import { LoggerContext, LoggerContextProps } from "../../../../contexts/LoggerContext.ts";
import { TutorialToggle } from "../../../LoginChecks/Tutorial/Tutorial.tsx";

function CommandLogger() {
  const navigate = useNavigate();
  const token = useContext(AuthContext).token;
  const { pentestId, currentWindow } = useContext(PentestContext);

  const [flagMode, setFlagMode] = useState(false);

  const [highlightCommands, setHighlightCommands] = useState<boolean[]>([]);
  const [highlightRequests, setHighlightRequests] = useState<boolean[]>([]);
  const [selectedIOBlocks, setSelectedIOBlocks] = useState<IOBlock[]>([]);

  const [tokenDisplay, setTokenDisplay] = useState(false);
  const [emptyLogger, setEmptyLogger] = useState(true);

  const toggleFlagMode = useCallback(() => {
    if (flagMode) {
      setHighlightCommands([]);
      setHighlightRequests([]);
      setFlagMode(false);
      return;
    }
    setFlagMode(true);
  }, [flagMode]);

  const contextValue: LoggerContextProps = useMemo(() => {
    return {
      highlightCommands: highlightCommands,
      setHighlightCommands: setHighlightCommands,

      highlightRequests: highlightRequests,
      setHighlightRequests: setHighlightRequests,

      flagMode: flagMode,
      toggleFlagMode: toggleFlagMode,

      selectedIOBlocks: selectedIOBlocks,
      setSelectedIOBlocks: setSelectedIOBlocks,

      tokenDisplay: tokenDisplay,
      setTokenDisplay: setTokenDisplay,

      emptyLogger: emptyLogger,
      setEmptyLogger: setEmptyLogger,
    };
  }, [
    flagMode,
    highlightCommands,
    highlightRequests,
    setHighlightCommands,
    setHighlightRequests,
    toggleFlagMode,
    selectedIOBlocks,
    setSelectedIOBlocks,
    tokenDisplay,
    setTokenDisplay,
    emptyLogger,
    setEmptyLogger,
  ]);

  if (!token || pentestId === -1) navigate("/");

  const listsToken = tokenDisplay ? loggerStyle.listsToken : loggerStyle.listsNoToken;

  if (currentWindow !== "logger") return;
  return (
    <LoggerContext.Provider value={contextValue}>
      <TokenWidget />
      <div className={loggerStyle.lists + " " + listsToken}>
        <CommandWidget />
        <VulnWidget />
      </div>

      <TutorialToggle />
    </LoggerContext.Provider>
  );
}

export default CommandLogger;
